import { useOffline } from "@/hooks/use-offline";
import { useI18n } from "@/hooks/use-i18n";
import { WifiOff, Loader2, CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";

export default function OfflineBanner() {
  const { isOnline, isSyncing, pendingCount } = useOffline();
  const { t } = useI18n();
  const [showReconnected, setShowReconnected] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
    } else if (wasOffline) {
      setShowReconnected(true);
      const timer = setTimeout(() => {
        setShowReconnected(false);
        setWasOffline(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  if (isOnline && !isSyncing && !showReconnected) return null;

  return (
    <div
      className={`sticky top-0 z-[60] flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium transition-colors ${
        !isOnline
          ? "bg-orange-500 text-white"
          : isSyncing
          ? "bg-yellow-500 text-black"
          : "bg-green-500 text-white"
      }`}
    >
      {!isOnline ? (
        <>
          <WifiOff className="h-4 w-4" />
          <span>{t("offlineBanner")}</span>
          {pendingCount > 0 && (
            <span className="ml-1 rounded-full bg-white/20 px-2 py-0.5 text-xs">
              {pendingCount} {t("pendingEntries")}
            </span>
          )}
        </>
      ) : isSyncing ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>{t("syncing")}</span>
        </>
      ) : (
        <>
          <CheckCircle2 className="h-4 w-4" />
          <span>{t("syncComplete")}</span>
        </>
      )}
    </div>
  );
}
